<template>
  <div>
    <section class=" container section is-main-section">
      <form @submit.prevent="save">
        <div>
            <v-card-component title="Edit Vehicle Insurance Details" icon="mdi-bus">
               <v-card-actions>
        <router-link :to="{ name: 'vehicleInsurance' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
<v-row>
<v-col>
     <v-row>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Insurance Amount  <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="insuranceAmount" step="any" required class="my-0 py-1" type="number">
        </v-text-field>
      </v-col>
        <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Insurance Number <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="insuranceNumber" required class="my-0 py-1">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium"> Insurance Company <span class="error--text ml-1">*</span></span>
        <v-text-field v-model.trim="insuranceCompany" required class="my-0 py-1">
        </v-text-field>
      </v-col>
          <v-col cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> Insurance Start Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="insuranceStartdate" required />
            </v-col>
      <v-col cols="12" lg="4" md="6">
              <label class="body-2 font-weight-medium"> Insurance Expiry Date <span class="error--text">*</span></label>
              <custom-date-picker v-model="insuranceExpDate" :minToDate="this.insuranceStartdate" required />
            </v-col>
    </v-row>
</v-col>
</v-row>
 <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label">
                  Upload Vehicle Insurance Details
                </label>
                <b-field class="file is-primary">
                  <b-upload @input="onFilechange()" v-model="dropFile" multiple class="file-label">
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <span class="has-text-danger">Allowed files:  .png, .jpg, .jpeg, .pdf </span>
<br/><br/> <span class="has-text-danger">File's that are not supported will be removed automatically!</span>
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                  </div>
                </span>
              </div>
            </div>
            <button class="button is-success" :disabled="hasClicked" type="submit" style="margin-top:20px;margin-right:100px;">Save</button>
          </div>
          <span v-if="dropFile1.length > 0">
        <span style="margin-top:50px;" class="has-text-primary">Already Uploaded Documents</span>
                    <div  class="tags" v-for="(file, i) in dropFile1" :key="i">
                     <div @click="download(file.urlPath)" class="tag is-primary">
                        {{ file.name }}
                      </div>

                      <button class="delete is-small" type="button"
                        @click="deleteDropFile1(file.id)"></button>
                    </div>
                  </span>
  </v-card-component>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
export default {
  name: 'editVehicleInsurance',
  props: ['insuranceID'],
  components: {
    VCardComponent,
    CustomDatePicker
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      vehicleID: '',
      insuranceAmount: null,
      insuranceNumber: '',
      insuranceCompany: '',
      insuranceStartdate: '',
      insuranceExpDate: '',
      vehicleInsuranceData: [],
      dropFile1: [],
      vehicleInsuranceDocumentData: [],
      title: '',
      hasClicked: false,
      deleteFileIdArr: [],
      loader: true,
      isWrite: false,
      allowedFiles: [
        'png', 'jpg', 'jpeg', 'pdf'
      ]
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.vehicleInsuranceDetails()
    await this.vehicleInsuranceDetailsDocuments()
  },
  methods: {
    vehicleInsuranceDetails: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicleinsurancedetails/${this.insuranceID}`)
        this.vehicleInsuranceData = data
        this.insuranceAmount = this.vehicleInsuranceData.insuranceAmount
        this.insuranceNumber = this.vehicleInsuranceData.insuranceNumber
        this.insuranceCompany = this.vehicleInsuranceData.insuranceCompany
        this.insuranceStartdate = moment(this.vehicleInsuranceData.insurancestartDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.insuranceExpDate = moment(this.vehicleInsuranceData.insuranceExpDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    vehicleInsuranceDetailsDocuments: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicleinsurancedetails/${this.insuranceID}`)
        this.vehicleInsuranceDocumentData = data
        this.dropFile1 = this.vehicleInsuranceDocumentData.vehicleDocumentsMaps
        if (this.dropFile1) {
          this.dropFile1.forEach(docID => {
            docID.name = docID.urlKey.substring(docID.urlKey.lastIndexOf('/') + 1)
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach(element => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
        }
      })
    },
    save: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.deleteFileIdArr.length > 0) {
          this.deleteFileIdArr.forEach(docID => {
            this.deleteDocument(docID)
          })
        }
        let formData = new FormData()
        formData.append('insuranceAmount', this.insuranceAmount)
        formData.append('insuranceNumber', this.insuranceNumber)
        formData.append('insuranceCompany', this.insuranceCompany)
        formData.append('insurancestartDate', this.insuranceStartdate)
        formData.append('insuranceExpDate', this.insuranceExpDate)
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('vehicleInsuranceAttachements', this.dropFile[i])
        }
        // for (var pair of formData.entries()) {
        //   console.log(pair)
        // }
        this.hasClicked = true

        await http.put(`${constants.API_URL}/api/transport/vehicledetails/vehicleinsurancedetails/${this.insuranceID}`, formData)
        this.loader = false
        this.loadingComponent.close()
        this.$router.push({ name: 'vehicleInsurance' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        await http.get(`${constants.API_URL}/api/transport/vehicledetails/vehicleinsurancedetails/status/${deldocID}`)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    }
  }
}
</script>
